import { HttpHeaders } from "@angular/common/http";
import { Component, EventEmitter, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "@kdose/ng-auth";
import { MessageService } from "primeng/api";
import { takeUntil } from "rxjs";
import { SKIP_HTTP_ERRORS } from "./shared/http-error-interceptor.service";
import { NotificationService } from "./shared/notification.service";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	standalone: false,
})
export class AppComponent implements OnInit {
	private readonly destroy$ = new EventEmitter<void>();

	constructor(
		private auth: AuthenticationService,
		private router: Router,
		private notify: NotificationService,
		private messageService: MessageService,
	) {}

	ngOnInit() {
		const headers = new HttpHeaders({
			[SKIP_HTTP_ERRORS]: [401],
		});
		this.auth
			.initializeAuthentication({ headers })
			.then(() => this.handleUserData())
			.catch((error) => {
				this.notify.acknowledgeRequired(
					"Fehler beim Initialisieren",
					"Server nicht erreichbar oder antwortet nicht",
					"error",
				);
				console.log({ error });
			});
	}

	dismissMessage(key: string) {
		this.messageService.clear(key);
	}

	private handleUserData() {
		this.auth.userData.pipe(takeUntil(this.destroy$)).subscribe((data) => {
			if (data?.authorities?.includes("PASSWORD_CHANGE_REQUIRED")) {
				setTimeout(() => this.router.navigateByUrl("/passwort-aendern"), 1);
			}
		});
	}
}
